import { defu } from 'defu'
import routerOptions from '#build/router.options.mjs'
const sensitiveMatcher = (m,p)=>{return [];}
const foldedMatcher = sensitiveMatcher
export default (path) => routerOptions.sensitive
  ? defu({}, ...sensitiveMatcher('', path).map(r => r.data).reverse())
  : defu({}, ...foldedMatcher('', typeof path === 'string' ? path.toLowerCase() : path).map(r => r.data).reverse())